import { FC } from 'react';
import css from './box.module.scss';
import { BoxProps } from './interface';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';
import CloseIcon from '@/components/UI/svg/smartDevicesTeaser/CloseIcon';

const WaveTwoBox: FC<BoxProps> = (props) => {
    const { useLang } = useGlobal();
    const { t } = useLang('glacierwave.teaser');

    return (
        <div className={css.waveTwoBox}>
            <CloseIcon className="close-icon" onClick={props.handleBoxClose} />
            <div className="product-modal-content-box">
                <div className="product-title">{t('product_wave_two')}</div>
                <div className="intro-container">
                    <div className="left-box">
                        <div className="left-top-box intro-box">
                            <NextImage
                                webpSrc={require('@publicLocal/glacier-and-wave-2/pc/mask/wave-1.webp')}
                                src={require('@publicLocal/glacier-and-wave-2/pc/mask/wave-1.jpg')}
                            />
                            <div className="intro-box-title left-top-title">{t('wave_comfort')}</div>
                            <div className="intro-text">{t('mask_hrs')}</div>
                        </div>
                        <div className="left-bottom-box intro-box">
                            <NextImage
                                webpSrc={require('@publicLocal/glacier-and-wave-2/pc/mask/wave-4.webp')}
                                src={require('@publicLocal/glacier-and-wave-2/pc/mask/wave-4.jpg')}
                            />
                            <div className="intro-box-title">{t('wave_fits')}</div>
                        </div>
                    </div>
                    <div className="right-box">
                        <div className="center-box intro-box">
                            <NextImage
                                webpSrc={require('@publicLocal/glacier-and-wave-2/pc/mask/wave-2.webp')}
                                src={require('@publicLocal/glacier-and-wave-2/pc/mask/wave-2.jpg')}
                            />
                            <div className="center-box-title">
                                {t.rich('wave_fastest_cooling', {
                                    left: (text: string) => <span className="intro-left-text">{text}</span>,
                                    right: (text: string) => <span className="intro-right-text">{text}</span>,
                                })}
                            </div>
                        </div>
                        <div className="right-top-box intro-box">
                            <NextImage
                                webpSrc={require('@publicLocal/glacier-and-wave-2/pc/mask/wave-3.webp')}
                                src={require('@publicLocal/glacier-and-wave-2/pc/mask/wave-3.jpg')}
                            />
                            <div className="intro-box-title">{t('wave_perfect')}</div>
                            <div className="intro-text">
                                {t.rich('mask_db', {
                                    num: (text: string) => <span className="blue-num">{text}</span>,
                                })}
                            </div>
                        </div>

                        <div className="right-center-box intro-box">
                            <div className="icon-box">
                                <NextImage
                                    webpSrc={require('@publicLocal/glacier-and-wave-2/pc/mask/wave-5-top.webp')}
                                    src={require('@publicLocal/glacier-and-wave-2/pc/mask/wave-5-top.jpg')}
                                />
                            </div>
                            <div className="intro-box-title">{t('greener_way')}</div>
                        </div>
                        <div className="right-bottom-box intro-box">
                            <div className="icon-box">
                                <NextImage
                                    webpSrc={require('@publicLocal/glacier-and-wave-2/pc/mask/wave-5-bottom.webp')}
                                    src={require('@publicLocal/glacier-and-wave-2/pc/mask/wave-5-bottom.jpg')}
                                />
                            </div>
                            <div className="intro-box-title">{t('wave_ways')}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WaveTwoBox;
